import './index.less';

import React from 'react';
import { Button, Icon, Progress, message } from 'antd';
import { connect } from 'react-redux';
import {
  NormalObj,
  MyIcon,
  getSearchParams,
  getToken,
  getLeagueId,
  getUserId,
  getType,
  mergeProps,
  isFzxxUnion,
  isPaper,
} from '../../util';
import * as action from '../../redux/action/vod.action';
import api from '../../config/api/index';
import axios from 'axios';
import AxiosWrap from '../../lib/request';
import Alert from '../Alert/Alert';
import TrackRequest from '../../lib/trackRequest';
import downloadSuccess from '../../components/downloadSuccess';
import { isProhibit } from '../../util/prohibitShow';
import { permitDownload } from '../../util/permitDownload';
import { showPPTLearningPlanViewerModal } from '../ppt-learning-plan-viewer';
import WatchFileUpdateRecordButton from './watch-file-update-record-button';
import { downloadFile } from '../../util/download_file';
import { downloadFileByALink, downloadFileByBlob } from '../../util/file';
import StaticLoad from '../StaticLoad';
import { ReactComponent as StarIcon } from '../../assets/svg-icons/star.svg';
import {
  ReactComponent as ArrowNarrowUpRightIcon,
} from '../../assets/svg-icons/arrow-narrow-up-right.svg';
import { ReactComponent as DownloadIcon } from '../../assets/svg-icons/download.svg';
import { ReactComponent as FileIcon } from '../../assets/svg-icons/file.svg';

const { CancelToken } = axios;
const LEARNING_PLAN_FILE_EXTENSIONS = ['ppt', 'pptx'];

// 学案的文件状态
enum LearningPlanRelationStatus {
  // 正在生成
  Generating = 'GENERATING',
  // 生成成功并且包含文件
  SuccessWithFile = 'SUCCESS_WITH_FILE',
  // 生成成功但是没有文件
  SuccessWithoutFile = 'SUCCESS_WITHOUT_FILE',
  // 生成失败
  Failed = 'FAILED',
}

enum ResourceRelationType {
  ClassLearningPlan = 'CLASS_LEARNING_PLAN',
  SupplementQuestionnaire = 'SUPPLEMENT_QUESTIONNAIRE',
}

interface RelationFile {
  relationType: ResourceRelationType;
  relationStatus?: LearningPlanRelationStatus;
  relatedFileId: string;
  relatedFileName: string;
  selfFile: {
    fileId: string | null;
    bid: string;
  } | null;
}

interface Iprops {
  data: NormalObj;
  goToPage?: () => void;
  lessonId: string;
  goToPreview?: (data: any) => void;
  downloadAll?: boolean;
  onCallback?: () => void;
  downloadEntrance: number; // 1 课程课时入口 2 资源包入口 3 全局搜索入口
  previewType: 0 | 1;
  watchEntrance?: number; // 预览入口
  functionConfig: NormalObj;
}
interface Istate {
  loading: boolean;
  title: string;
  isError: boolean;
  percent: number;
  // 点击下载标志
  clickDownload: boolean;
}

function isSupportType(type: string, isSupport?: Boolean | undefined) {
  const supportType = [
    'ppt',
    'pptx',
    'jpg',
    'png',
    'mp3',
    'wma',
    'wav',
    'mp4',
    'swf',
    'xls',
    'xlsx',
    'doc',
    'docx',
    'pdf',
  ];
  if (!isSupport) {
    return supportType.indexOf(type.toLowerCase()) > -1;
  } else {
    return supportType.indexOf(type.toLowerCase()) === -1;
  }
}

class DownloadItem extends React.PureComponent<Iprops, Istate> {
  cancel: any;
  constructor(props: Iprops) {
    super(props);
    this.state = {
      loading: false,
      title: '',
      percent: 0,
      isError: false,
      clickDownload: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { downloadAll } = nextProps;
    const { loading } = this.state;
    if (downloadAll && !loading) this.onDownload({});
  }

  /**
   * 转化课件名
   *
   * @params name 课件名字
   * @params extension 课件后缀名
   *
   */
  getFileName(name: any, extension: any) {
    if (extension) {
      if (name.includes(`.${extension}`)) {
        return name;
      } else {
        return `${name}.${extension.toLocaleLowerCase()}`;
      }
    }
    return name;
  }

  onDownload = async (e: any) => {
    this.setState({
      percent: 0,
    });
    e.stopPropagation && e.stopPropagation();
    const { data, lessonId } = this.props;
    if (!isProhibit(data)) return null;
    const searchParam = getSearchParams(window.location.search);
    const title = data.fileName;
    const fileName = this.getFileName(data.fileName, data.extension);
    this.setState({ isError: false });

    const _name_ = encodeURIComponent(fileName);

    // 普通作业5+pdf，1级加密
    if (data.category === 5 && data.extension.toLowerCase() === 'pdf') {
      try {
        const res = await AxiosWrap({
          url: `/files/${data.fileId}/watermark?fileName=${_name_}`,
          method: 'get',
        });
        const encryptFileId = res.data && res.data.fileId;
        if (encryptFileId) {
          // 浏览器下载
          this.downloadFileWithBrowser(title, undefined, encryptFileId);
        } else {
          Alert.open('该文件暂时无法下载，请联系客服');
        }
      } catch (err) {
        const error = err as { data?: { message?: string } };
        if (error.data && error.data.message) {
          message.error(error.data.message);
        }
      }

      // 加密试卷下载状态
      const url = `${api.api}/resources/${data.resourceGuid}/files/${
        data.fileId
      }/download?courseId=${searchParam.courseId || data.courseId}&lessonId=${
        lessonId || data.lessonId
      }&fileName=${_name_}&originalFileId=${data.originalFileId || ''}&documentId=${
        data.documentId || ''
      }`;
      if (url) {
        AxiosWrap({
          url,
          method: 'get',
        });
      }
    }
    // 普通试卷6+pdf，2级加密
    else if (data.category === 6 && data.extension.toLowerCase() === 'pdf') {
      const userId = getUserId();
      // 试卷加密
      const link = `${
        api.resourceCenterDownload
      }/FileService/DownloadPdf?usertoken=${getToken()}&fileid=${
        data.fileId
      }&leagueId=${getLeagueId()}&relationUserId=${userId}&fileName=${_name_}`;
      // 浏览器下载
      // this.downloadBlob(title, '', data, link, true, 20);
      this.downloadFileWithBrowser(title, link);

      // 加密试卷下载状态

      const url = `${api.api}/resources/${data.resourceGuid}/files/${
        data.fileId
      }/download?courseId=${searchParam.courseId || data.courseId}&lessonId=${
        lessonId || data.lessonId
      }&fileName=${_name_}&originalFileId=${data.originalFileId || ''}&documentId=${
        data.documentId || ''
      }`;
      if (url) {
        AxiosWrap({
          url,
          method: 'get',
        });
      }
    } else {
      const _name_ = encodeURIComponent(data.fileName);
      const url = `${api.api}/resources/${data.resourceGuid}/files/${
        data.fileId
      }/download?courseId=${searchParam.courseId || data.courseId}&lessonId=${
        lessonId || data.lessonId
      }&fileName=${_name_}&originalFileId=${data.originalFileId || ''}&documentId=${
        data.documentId || ''
      }`;
      if (url) {
        AxiosWrap({
          url,
          method: 'get',
        })
          .then((res: any) => {
            this.webDownloadFn(res, title, data);
          })
          .catch((err) => {
            if (err && err.data) {
              message.error(err.data.message);
            }
          });
      }
    }
  };

  // 浏览器下载
  webDownloadFn(res: any, title: any, data: any) {
    let url = res.data.cdnUrl || res.data.url;
    if (url) {
      url = `https${url.substring(url.indexOf(':'))}`;
      // 浏览器下载
      // this.downloadBlob(title, '', data, url);
      this.downloadFileWithBrowser(title);
    } else {
      Alert.open('该文件暂时无法下载，请联系客服');
    }
  }

  // 如果存在1级加密文件id，则使用加密文件下载
  // 如果存在2级加密文件encryptUrl下载地址，则使用2级加密文件下载
  downloadFileWithBrowser(title: any, encryptUrl?: string, encryptFileId?: string) {
    this.setState({ loading: true, title });
    const { data: lessonInfo, downloadEntrance } = this.props;

    try {
      const { fileId, fileName } = lessonInfo;
      downloadFile(encryptFileId || fileId, () => {}, fileName, encryptUrl);
      downloadSuccess();
      // 下载资料 埋点
      const searchParam = getSearchParams(window.location.search);
      const { lessonId, data } = this.props;
      TrackRequest({
        name: 'download_material',
        data: {
          course_id: searchParam.courseId || data.courseId,
          period_id: lessonId || data.lessonId,
          material_id: lessonInfo.resourceGuid,
          material_type: lessonInfo.category,
          download_entrance: downloadEntrance,
        },
      });
      // 全局搜索入口不显示下载按钮
      this.setState({
        loading: false,
        clickDownload: downloadEntrance === 3 ? false : true,
        percent: 0,
      });
      this.props.onCallback && this.props.onCallback();
    } catch (err) {
      this.props.onCallback && this.props.onCallback();
      this.setState({ isError: true, loading: false, percent: 0 });
    }
  }

  downloadBlob(
    title: any,
    trackData: any,
    data: any,
    url: any,
    noCache?: boolean,
    basePercent?: number,
  ) {
    this.setState({ loading: true, title });
    if (basePercent) {
      let n = 0;
      const timer = window.setInterval(() => {
        if (n >= 3) {
          window.clearInterval(timer);
        }
        n++;
        this.setState({ percent: Math.floor(basePercent / 4) * n });
      }, 20);
    }
    const { data: lessonInfo, downloadEntrance } = this.props;
    let cache = {};
    !noCache && (cache = { 'Cache-Control': 'no-cache' });
    axios({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: cache,
      onDownloadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (basePercent) {
          // 加密过程模拟进度条
          const _basePercent_ = Math.floor(basePercent / 4) * 4;
          percent >= _basePercent_ && this.setState({ percent });
        } else {
          this.setState({ percent });
        }
        if (percent === 100 || percent === Infinity) {
          setTimeout(() => {
            this.setState({ loading: false, percent: 0 });
            this.props.onCallback && this.props.onCallback();
          }, 2000);
        }
      },
      cancelToken: new CancelToken((c) => {
        this.cancel = c;
      }),
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', title);
        document.body.appendChild(link);
        link.click();
        downloadSuccess();
        // 下载资料 埋点
        const searchParam = getSearchParams(window.location.search);
        const { lessonId, data } = this.props;
        TrackRequest({
          name: 'download_material',
          data: {
            course_id: searchParam.courseId || data.courseId,
            period_id: lessonId || data.lessonId,
            material_id: lessonInfo.resourceGuid,
            material_type: lessonInfo.category,
            download_entrance: downloadEntrance,
          },
        });
      })
      .catch((err) => {
        this.props.onCallback && this.props.onCallback();
        if (axios.isCancel(err)) {
          this.setState({ isError: false, loading: false });
        } else {
          this.setState({ isError: true, loading: false });
        }
      });
  }

  stopDownload = (e: any) => {
    const { percent } = this.state;
    e.stopPropagation();
    if (percent < 100) {
      this.cancel();
      this.setState({ percent: 0 });
    }
  };

  viewLearningPlan = (e: React.MouseEvent<HTMLElement>, wordFile: RelationFile) => {
    e.stopPropagation();
    const { data, lessonId, previewType } = this.props;
    const searchParam = getSearchParams(window.location.search);
    showPPTLearningPlanViewerModal({
      pptFileId: data.fileId,
      wordFileId: wordFile.relatedFileId,
      previewContext: {
        type: previewType,
        pptFileName: data.fileName,
        wordFileName: wordFile.relatedFileName,
        resourceId: data.resourceGuid,
        courseId: searchParam.courseId || data.courseId,
        lessonId: lessonId || data.lessonId,
        originalFileId: data.originalFileId || '',
        documentId: data.documentId || '',
        selfFile: {
          fileId: wordFile.selfFile?.fileId ?? null, // 用户自己编辑过的文件信息
          bid: wordFile.selfFile?.bid!, // 用于编辑的参数
        },
      },
    });
  };

  downloadSupplementQuestionnaire = async (
    e: React.MouseEvent<HTMLElement>,
    relationFile: RelationFile,
  ) => {
    e.stopPropagation();
    const { relatedFileId, relatedFileName, selfFile } = relationFile;
    const { data, lessonId } = this.props;
    const searchParam = getSearchParams(window.location.search);
    const downloadFileId = selfFile?.fileId ?? relatedFileId;
    StaticLoad.show();

    try {
      const res = await (AxiosWrap as any)({
        url: `${api.api}/resources/${data.resourceGuid}/files/${downloadFileId}/download`,
        method: 'get',
        params: {
          courseId: searchParam.courseId || data.courseId,
          lessonId: lessonId || data.lessonId,
          fileName: relatedFileName,
          originalFileId: data.originalFileId || '',
          documentId: data.documentId || '',
        },
      });
      let downloadUrl = res.data.cdnUrl || res.data.url;
      if (!downloadUrl) {
        message.error('该文件暂时无法下载，请联系客服');
        return;
      }
      downloadUrl = `https${downloadUrl.substring(downloadUrl.indexOf(':'))}`;
      try {
        await downloadFileByBlob(downloadUrl, relatedFileName);
      } catch (error) {
        console.error(error);
        downloadFileByALink(downloadUrl, relatedFileName);
      }
      downloadSuccess();
    } catch (error) {
      console.error(error);
      message.error('该文件暂时无法下载，请稍后重试');
    } finally {
      StaticLoad.remove();
    }
  };

  renderClassLearningPlan = (relationFile: RelationFile) => {
    const relationStatus =
      relationFile.relationStatus || LearningPlanRelationStatus.SuccessWithFile;
    const isGenerating = relationStatus === LearningPlanRelationStatus.Generating;

    if (
      !isGenerating &&
      relationStatus !== LearningPlanRelationStatus.SuccessWithFile
    ) {
      return null;
    }

    return (
      <div className="learning-plan-card" onClick={(e) => e.stopPropagation()}>
        <div className="learning-plan-info">
          <div className="learning-plan-title">
            {isGenerating ? <Icon type="loading" /> : <StarIcon />}
            <span>{isGenerating ? 'AI 正在生成课中学案...' : 'AI 生成课中学案'}</span>
          </div>
          {isGenerating && (
            <div className="learning-plan-description">
              本课件配套的课中学案正在由AI生成，请稍等几分钟后刷新页面查看结果。若AI最终没有可生成内容，此处不会出现入口。
            </div>
          )}
          {!isGenerating && (
            <span className="learning-plan-file-name" title={relationFile.relatedFileName}>
              {relationFile.relatedFileName}
            </span>
          )}
        </div>
        {!isGenerating && (
          <button
            type="button"
            className="learning-plan-preview-button"
            onClick={(e) => this.viewLearningPlan(e, relationFile)}
          >
            <ArrowNarrowUpRightIcon />
            预览并下载
          </button>
        )}
      </div>
    );
  };

  renderSupplementQuestionnaire = (relationFile: RelationFile) => {
    const relationStatus =
      relationFile.relationStatus || LearningPlanRelationStatus.SuccessWithFile;

    if (relationStatus !== LearningPlanRelationStatus.SuccessWithFile) {
      return null;
    }

    return (
      <div className="learning-plan-card" onClick={(e) => e.stopPropagation()}>
        <div className="learning-plan-info">
          <div className="learning-plan-title supplement-questionnaire-title">
            <FileIcon />
            <span>配套资料</span>
          </div>
          <span className="learning-plan-file-name" title={relationFile.relatedFileName}>
            {relationFile.relatedFileName}
          </span>
        </div>
        <button
          type="button"
          className="learning-plan-preview-button"
          onClick={(e) => this.downloadSupplementQuestionnaire(e, relationFile)}
        >
          <DownloadIcon />
          下载
        </button>
      </div>
    );
  };

  renderRelationFile = (relationFile: RelationFile, index: number) => {
    const key = `${relationFile.relationType}-${relationFile.relatedFileId || index}`;

    switch (relationFile.relationType) {
      case ResourceRelationType.ClassLearningPlan:
        return (
          <React.Fragment key={key}>
            {this.renderClassLearningPlan(relationFile)}
          </React.Fragment>
        );
      case ResourceRelationType.SupplementQuestionnaire:
        return (
          <React.Fragment key={key}>
            {this.renderSupplementQuestionnaire(relationFile)}
          </React.Fragment>
        );
      default:
        return null;
    }
  };

  previewClick = (e: any) => {
    e.stopPropagation && e.stopPropagation();
    const { data, watchEntrance, lessonId } = this.props;
    const searchParam = getSearchParams(window.location.search);
    const {
      fileId: id,
      extension,
      category,
      fileName,
      // courseId,
      // lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    } = data;
    if (isSupportType(extension, true) || isPaper(category, extension)) {
      message.error('暂不支持预览！', 1);
      return;
    }

    const _courseId = searchParam.courseId || data.courseId;
    const _lessonId = lessonId || data.lessonId;

    // 预览埋点
    if (typeof watchEntrance === 'number') {
      const trackData = {
        course_id: _courseId,
        period_id: _lessonId,
        material_id: resourceGuid,
        material_type: category,
        watch_entrance: watchEntrance,
      };
      TrackRequest({ name: 'watch_material', data: trackData });
    }

    this.goToPreView(
      id,
      encodeURIComponent(fileName),
      _courseId,
      _lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    );
  };

  goToPreView = async (
    id: string,
    fileName: string,
    courseId: string,
    lessonId: string,
    resourceGuid: string,
    originalFileId: string,
    documentId: string,
  ) => {
    const data = await action.filePreview(
      id,
      1,
      fileName,
      courseId,
      lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    );
    if (data && data.fileId) {
      if (this.props.goToPreview) {
        this.props.goToPreview && this.props.goToPreview({ ...data, fileName });
      } else {
        this.props.goToPage && this.props.goToPage();
      }
    }
  };

  render() {
    const {
      data,
      functionConfig: { downloadFile = false },
    } = this.props;
    const { loading, isError, percent, clickDownload } = this.state;
    const { updateState } = data;
    const relationFiles: RelationFile[] = data.relationFiles || [];
    const hasVisibleRelationFile =
      data.category === 2 &&
      LEARNING_PLAN_FILE_EXTENSIONS.includes((data.extension || '').toLowerCase()) &&
      relationFiles.some(
        ({ relationType, relationStatus }) => {
          const status = relationStatus || LearningPlanRelationStatus.SuccessWithFile;
          const isSupportedRelationType =
            relationType === ResourceRelationType.ClassLearningPlan ||
            relationType === ResourceRelationType.SupplementQuestionnaire;

          return (
            isSupportedRelationType &&
            (status === LearningPlanRelationStatus.SuccessWithFile ||
              (relationType === ResourceRelationType.ClassLearningPlan &&
                status === LearningPlanRelationStatus.Generating))
          );
        },
      );
    const mainRow = (
      <>
        <MyIcon className="iconfont" type={getType(data).type} />
        <div className="item-left">
          <div className="item-info">
            <div className="attachment-item-inner-name" title={data.fileName}>
              {/* {data.previewState && <span className="state-icon pre-icon">已查看</span>} */}
              {updateState && <span className="state-icon update-icon">有更新</span>}
              {!updateState && !isFzxxUnion() && (data.downloadState || clickDownload) && (
                <span className="state-icon down-icon">已下载</span>
              )}
              {data.fileName}
            </div>
          </div>

          {loading && !isError && (
            <div className="download-area">
              <Progress
                percent={this.state.percent}
                status={percent === 100 ? 'success' : !isError ? 'active' : 'exception'}
              />
              <MyIcon
                className="stop-btn"
                type="iconic_del"
                title="取消下载"
                onClick={this.stopDownload}
              />
            </div>
          )}
          {isError && (
            <div
              style={{
                color: '#F5222D',
                padding: '12px 0 23px 60px',
                position: 'relative',
                lineHeight: 0,
              }}
            >
              下载失败!
              <span
                style={{
                  position: 'absolute',
                  color: 'rgba(0, 0, 0, 0.65)',
                  right: '0',
                  fontSize: '8px',
                  top: 8,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ loading: false, isError: false });
                }}
              >
                <MyIcon type="iconic_del" title="关闭" />
              </span>
            </div>
          )}
        </div>
        <div className="item-right">
          <WatchFileUpdateRecordButton historyFiles={data?.historyFiles} />
          {!loading && downloadFile && isProhibit(data) && !permitDownload() && (
            <Button type="primary" onClick={this.onDownload}>
              下载
            </Button>
          )}
        </div>
      </>
    );

    return (
      <div
        className={`download-item ${
          hasVisibleRelationFile ? 'download-item-with-relations' : ''
        } ${data.expiryState ? 'expire-item' : ''}`}
        onClick={this.previewClick}
      >
        <MyIcon className="iconfont expire-icon" type="iconziyuan" />
        {hasVisibleRelationFile ? (
          <div className="item-content">
            <div className="item-main-row">{mainRow}</div>
            {relationFiles.map(this.renderRelationFile)}
          </div>
        ) : (
          mainRow
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  functionConfig: { ...state.DynamicControl.functionConfig },
});

export default connect(mapStateToProps, mergeProps)(DownloadItem);
